import {postObject} from '../../../Common/post';

export let postMaintenance = async(props, user) => {
    let alerts =  {
        open: true,
        severity: 'error',
        message: "Error when deleting. No record has been selected to delete. Contact the website administrator for more details."
    };

    let formulary={
        Nombre: props.attribute,
        UsuarioInsercion: user?.Email,
        FechaInsercion: new Date()
    }

    switch(props.type) {
        case process.env.REACT_APP_MANAGEMENT_EGT:
            let energetic = await postObject("certificates/energeticos/create", null, formulary);
            alerts = setAlerts(energetic);
            break;
        case process.env.REACT_APP_MANAGEMENT_EXT:
            let exeption = await postObject("certificates/retenciones/create", null, formulary);
            alerts = setAlerts(exeption);
            break;
        case process.env.REACT_APP_MANAGEMENT_RT:
            let index = await postObject("medidas/indices/create", null, formulary);
            alerts = setAlerts(index);
            break;
    }
    
    return alerts;
}

let setAlerts = (values) => {
	let response = '';
	if (values.data.codigo >= 200 && values.data.codigo <= 202) {
        response = {
            open: true,
            severity: 'success',
            message: values.data.mensaje
        };
    } else {
        response = {
            open: true,
            severity: 'error',
            message: values.data.mensaje
        };
    }
	
	return response
}